import { render, staticRenderFns } from "./ControlRowCol.vue?vue&type=template&id=65dc98a6&scoped=true"
import script from "./ControlRowCol.vue?vue&type=script&lang=ts"
export * from "./ControlRowCol.vue?vue&type=script&lang=ts"
import style0 from "./ControlRowCol.vue?vue&type=style&index=0&id=65dc98a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65dc98a6",
  null
  
)

export default component.exports